import {  useLocation,Location as ReactRouterLocationType } from 'react-router-dom';
import { type AppRoutePath } from './AppRoutes';

export type AppLocationState = object;

type Location<T>  =  ReactRouterLocationType<T> & {
  pathname: AppRoutePath;
  search: string;
  hash: string;
  state: T;
};

export const useAppLocation = () => {
  return useLocation() as Location<AppLocationState> 
};
